import { createFileRoute } from "@tanstack/react-router";
import React from "react";
import MainLayout from "../layouts/main/MainLayout";
import ChatPage from "@components/chat/ChatPage";

export const Route = createFileRoute("/chat")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <MainLayout pageProps={{ hideHeader: true }}>
      <ChatPage />
    </MainLayout>
  );
}
